import React from 'react';
import Filter from '../../Asset/images/icon/Filters-lines.svg';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FilterModal from '../FilterModal';

const FilterSection = ({
	category,
	handleOpenFilterModal,
	handleFilterChange,
	sortby,
	isFilterModalOpen,
	tags,
	selectedTags,
	selectedDurations,
	selectedLevels,
	handleApplyFilter,
	handleResetFilter,
	handleCloseFilterModal,
	selectedInstructors,
	instructors,
	products,
	selectedProducts
}) => {
	return (
		<>
			<div className="c-tab_cata-text">
				<div id="c-mobile_tab_hide" className="c-tab_cata mb-n9">
					<div className="row m-0 c-tab_box">
						<div className="col p-0">
							<div className="c-filter_btn c-filter_btn-lessons">
								<div
									className="c-filter_btn-one c-filter_btn-tags unique"
									style={{ cursor: 'pointer', padding: '0px' }}
								>
									<span
										onClick={handleOpenFilterModal}
										className="c-filters-btn"
										style={{
											padding: '10px 14px',
											display: 'flex',
											justifyContent: 'space-between'
										}}
									>
										<img src={Filter} alt="" />
										Filters
									</span>
									{isFilterModalOpen && (
										<FilterModal
											isOpen={isFilterModalOpen}
											tags={tags}
											checkedTags={selectedTags}
											checkedDuration={selectedDurations}
											checkedLevels={selectedLevels}
											handleApplyFilter={handleApplyFilter}
											handleResetFilter={handleResetFilter}
											handleClose={handleCloseFilterModal}
											checkedInstructors={selectedInstructors}
											instructors={instructors}
											products={products}
											checkedProducts={selectedProducts}
										/>
									)}
								</div>
								<div className="c-filter_btn-one">
									<ImportExportIcon size={24} />
									<span>Sort by</span>
									<select className="filterby" onChange={handleFilterChange} value={sortby}>
										<option value={'latest'}>Newest</option>
										<option value={'oldest'}>Oldest</option>
										<option value={'title_asc'}>Title (A - Z)</option>
										<option value={'title_desc'}>Title (Z - A)</option>
										<option value={'long_duration'}>Longest</option>
										<option value={'short_duration'}>Shortest</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>

				<h4>{category?.toUpperCase().split(' ')}</h4>
			</div>
		</>
	);
};

export default FilterSection;
